const tr = {
  // Legacy aliases
  add: 'Ekle', edit: 'Düzenle', save: 'Kaydet', cancel: 'İptal', delete: 'Sil',
  search: 'Ara', export: 'Dışa Aktar', download: 'İndir', signIn: 'Giriş Yap',
  chassis: 'Şasi', make: 'Marka', model: 'Model', year: 'Yıl', color: 'Renk',
  mileage: 'Kilometre', displacement: 'Motor Hacmi', transmission: 'Şanzıman',
  port: 'Liman', status: 'Durum', price: 'Fiyat', cost: 'Maliyet', fobPrice: 'FOB Fiyatı',
  condition: 'Durum', quantity: 'Miktar', category: 'Kategori', fitment: 'Uyumluluk',
  cutType: 'Kesim Tipi', sku: 'SKU', name: 'Ad', email: 'E-posta', password: 'Şifre',
  phone: 'Telefon', company: 'Şirket', country: 'Ülke', scan: 'QR Tara',
  priceQuotes: 'Fiyat Teklifleri', selectionOrders: 'Seçim Siparişleri', pricing: 'Fiyatlandırma',
  vehicles: 'Araçlar', engines: 'Motorlar', parts: 'Parçalar', containers: 'Konteynerler',
  customers: 'Müşteriler', requests: 'Talepler', employees: 'Personel', settings: 'Ayarlar',
  dashboard: 'Kontrol Paneli', inventory: 'Envanter', myStock: 'Stoğum',
  invoices: 'Faturalar', payments: 'Ödemeler', noData: 'Veri yok',
  loading: 'Yükleniyor...', totalUnits: 'Toplam Birim', printQR: 'QR Yazdır',
  whatsAppInquiry: 'WhatsApp Sorgusu', viewDetails: 'Detayları Gör',
  staffPortal: 'Personel Portalı', customerPortal: 'Müşteri Portalı',
  invalidCredentials: 'Geçersiz kimlik bilgileri',
  recentActivity: 'Son Aktivite', inventoryValue: 'Envanter Değeri',
  inTransit: 'Yolda', pendingRequests: 'Bekleyen Talepler',

  // Dashboard
  dash_welcome: 'Hoş geldiniz, {name}',
  dash_good_morning: 'Günaydın', dash_good_afternoon: 'İyi günler', dash_good_evening: 'İyi akşamlar',
  dash_financial_overview: 'finansal genel bakış',
  dash_units_in_account: 'hesabınızdaki birimler',
  dash_my_shipments: 'Gönderilerim', dash_on_the_way: 'Yolda', dash_arrived: 'Geldi',
  dash_no_shipments: 'Aktif gönderi yok',
  dash_recommended: 'Sizin İçin Önerilen', dash_available_units: 'Mevcut Birimler',
  dash_no_available: 'Mevcut birim yok.',
  dash_total_fob: 'Toplam FOB Değeri', dash_total_cost: 'Toplam Maliyet',
  dash_late_night: 'Gece Geç', dash_hello: 'Merhaba',
  dash_subtitle: 'Filonuz, parçalarınız ve gelen sevkiyatlarınıza genel bakış — gerçek zamanlı.',
  dash_local_time: 'YEREL SAAT', dash_status: 'DURUM', dash_all_systems_live: 'Tüm sistemler aktif',
  dash_view_recommendations: 'Önerileri gör', dash_my_stock: 'STOĞUM', dash_in_transit: 'YOLDA',
  dash_units: 'adet', dash_containers: 'konteyner', dash_browse_more: 'Daha fazla',
  dash_track_shipments: 'Sevkiyatları takip et', dash_browse_inventory_start: 'Envanteri inceleyin',
  dash_no_active_shipments: 'Aktif sevkiyat yok', dash_next_eta: 'Tahmini varış', dash_days: 'gün',
  dash_etas_confirming: 'Varış tarihleri onaylanıyor', dash_this_week: 'BU HAFTA',
  dash_arriving_soon: 'YAKINDA', dash_logistics: 'LOJİSTİK', dash_active_shipments: 'Aktif sevkiyatlar',
  dash_view_all: 'Tümünü gör', dash_shipment_empty: 'Birimler yüklendiğinde burada görünecek',
  dash_composition: 'DAĞILIM', dash_stock_breakdown: 'Stok dağılımı', dash_no_units_yet: 'Henüz birim yok',
  dash_browse_to_build: 'Stoğunuzu oluşturmak için envanteri inceleyin',
  dash_for_you: 'SİZİN İÇİN', dash_picked_based: 'Stoğunuza göre seçildi', dash_browse_all: 'Tümünü incele',
  dash_picking_units: 'Sizin için birimler seçiyoruz', dash_view_details: 'Detayları gör',
  dash_just_arrived: 'YENİ GELDİ', dash_similar: 'BENZİYOR', dash_today: 'Bugün', dash_tomorrow: 'Yarın',
  dash_gross_margin: 'Brüt Marj', dash_awaiting_pricing: 'Fiyat Bekliyor',
  dash_vehicle_fob: 'Araç FOB Toplamı', dash_engine_fob: 'Motor FOB Toplamı',
  dash_parts_fob: 'Parça FOB Toplamı', dash_total_freight: 'Toplam Navlun Maliyeti',
  dash_fob_by_make: 'Markaya Göre FOB', dash_no_priced_vehicles: 'Fiyatlandırılmış araç yok',
  dash_top_units: 'FOB\'a Göre En İyi 5 Birim', dash_no_priced_units: 'Fiyatlandırılmış birim yok',
  dash_margin: 'marj', dash_container_breakdown: 'Konteyner Mali Analiz',
  dash_no_containers: 'Konteyner yok',
  dash_container: 'Konteyner', dash_route: 'Rota', dash_units: 'Birimler',
  dash_freight_cost: 'Navlun Maliyeti', dash_fob_value: 'FOB Değeri',
  dash_net_after_freight: 'Navlun Sonrası Net',
  dash_receivables: 'Alacaklar', dash_total: 'Toplam', dash_current: 'Güncel',
  dash_overdue: 'Vadesi Geçmiş', dash_oldest: 'En Eski', dash_days: 'gün',
  dash_this_month: 'Bu Ay', dash_invoiced: 'Faturalandırıldı', dash_received: 'Alındı',
  dash_avg_margin: 'Ortalama Marj', dash_quotes_sent: 'Gönderilen Teklifler',
  dash_pending_actions: 'Bekleyen İşlemler', dash_receipts_verify: 'makbuz doğrulama bekliyor',
  dash_units_pricing: 'birim fiyatlandırma bekliyor', dash_invoices_overdue: 'vadesi geçmiş fatura',
  dash_customer_balances: 'Müşteri Bakiyeleri', dash_customer_overview: 'Müşteri Genel Bakış',
  dash_top_customers: 'En İyi Müşteriler (gelire göre)',
  dash_attention: 'Dikkat', dash_no_customer_data: 'Müşteri verisi yok.',
  dash_no_customers: 'Müşteri yok', dash_no_activity: 'Son aktivite yok',
  dash_price_quotes: 'Fiyat Teklifleri', dash_pending: 'Beklemede',
  dash_in_progress: 'Devam Ediyor', dash_quoted_week: 'Bu Hafta Teklif Verilen',
  dash_total_units: 'Toplam Birim',

  // Navigation
  nav_dashboard: 'Kontrol Paneli', nav_inventory: 'Envanter', nav_my_stock: 'Stoğum',
  nav_my_selection: 'Seçimim', nav_containers: 'Konteynerler', nav_requests: 'Talepler',
  nav_invoices: 'Faturalar', nav_payments: 'Ödemeler', nav_customers: 'Müşteriler',
  nav_employees: 'Personel', nav_settings: 'Ayarlar', nav_pricing: 'Fiyatlandırma',
  nav_price_quotes: 'Fiyat Teklifleri', nav_selection_orders: 'Seçim Siparişleri',
  nav_tasks: 'Görevler',
  nav_scan: 'Tara', nav_sign_out: 'Çıkış',

  // Buttons
  btn_save: 'Kaydet', btn_cancel: 'İptal', btn_delete: 'Sil', btn_edit: 'Düzenle',
  btn_add: 'Ekle', btn_submit: 'Gönder', btn_approve: 'Onayla', btn_reject: 'Reddet',
  btn_download: 'İndir', btn_upload: 'Yükle', btn_search: 'Ara', btn_export: 'Dışa Aktar',
  btn_clear: 'Temizle', btn_confirm: 'Onayla', btn_close: 'Kapat', btn_view: 'Görüntüle',
  btn_remove: 'Kaldır', btn_back: 'Geri', btn_next: 'İleri',
  btn_save_changes: 'Değişiklikleri Kaydet', btn_sign_in: 'Giriş Yap', btn_contact_us: 'Bize Ulaşın',

  // Login
  login_title: 'BIG STAR', login_subtitle: 'Araç İhracat Yönetimi',
  login_staff_portal: 'Personel Portalı', login_customer_portal: 'Müşteri Portalı',
  login_username: 'Kullanıcı Adı', login_email: 'E-posta', login_password: 'Şifre',
  login_remember: 'Beni Hatırla', login_invalid: 'Geçersiz kimlik bilgileri',
  login_timeout: 'Oturumunuz sona erdi. Tekrar giriş yapın.',

  // Inventory
  inv_add_to_stock: 'Stoğuma Ekle', inv_in_stock: 'Stoğumda',
  inv_reserved: 'Ayrılmış', inv_sold: 'Satıldı', inv_available: 'Mevcut',
  inv_search_placeholder: 'Araç, parça, motor ara...',
  inv_no_results: 'Sonuç bulunamadı', inv_vehicle: 'Araç', inv_engine: 'Motor',
  inv_spare_part: 'Yedek Parça', inv_vehicles: 'Araçlar', inv_engines: 'Motorlar',
  inv_parts: 'Parçalar', inv_all: 'Tümü', inv_no_data: 'Veri yok',
  inv_all_items: 'Tüm Öğeler', inv_all_status: 'Tüm Durumlar', inv_all_makes: 'Tüm Markalar',
  inv_all_years: 'Tüm Yıllar', inv_all_transmissions: 'Tüm Şanzımanlar',
  inv_all_conditions: 'Tüm Durumlar', inv_all_categories: 'Tüm Kategoriler',
  inv_all_countries: 'Tüm Ülkeler', inv_item: 'Öğe', inv_details: 'Detaylar',
  inv_days: 'Gün', inv_show: 'Göster', inv_request_parts: 'Parça Talep Et',
  inv_how_want_vehicle: 'Bu aracı nasıl istiyorsunuz?',
  inv_full_vehicle: 'Tam Araç', inv_full_vehicle_desc: 'Olduğu gibi komple',
  inv_custom: 'Özel', inv_custom_desc: 'Talebinizi açıklayın',

  // Detail labels
  detail_make: 'Marka', detail_model: 'Model', detail_year: 'Yıl', detail_chassis: 'Şasi',
  detail_color: 'Renk', detail_mileage: 'Kilometre', detail_grade: 'Sınıf', detail_score: 'Puan',
  detail_engine_code: 'Motor Kodu', detail_transmission: 'Şanzıman',
  detail_fuel: 'Yakıt Tipi', detail_steering: 'Direksiyon', detail_drive: 'Tahrik Sistemi',
  detail_condition: 'Durum', detail_status: 'Durum', detail_price: 'Fiyat',
  detail_fob: 'FOB Fiyatı', detail_displacement: 'Motor Hacmi',
  detail_port: 'Liman', detail_city: 'Şehir', detail_seats: 'Koltuk',
  detail_category: 'Kategori', detail_fitment: 'Uyumluluk', detail_quantity: 'Miktar',
  detail_sku: 'SKU', detail_cut_type: 'Kesim Tipi', detail_photos: 'Fotoğraflar',
  detail_notes: 'Notlar', detail_location: 'Konum', detail_manufacturer: 'Üretici',
  detail_assign_customer: 'Müşteriye Ata', detail_assigned_to: 'Atanan',
  detail_request_parts: 'Bu Araçtan Parça Talep Et',

  // Statuses
  status_available: 'Mevcut', status_assigned: 'Atandı', status_sold: 'Satıldı',
  status_shipped: 'Gönderildi', status_in_transit: 'Yolda', status_at_port: 'Limanda',
  status_customs: 'Gümrük', status_delivered: 'Teslim Edildi', status_japan_yard: 'Japonya Sahası',
  status_loading: 'Yükleniyor', status_loaded: 'Yüklendi', status_pending: 'Beklemede',
  status_approved: 'Onaylandı', status_rejected: 'Reddedildi', status_planning: 'Planlama',
  status_booked: 'Rezerve', status_sealed: 'Mühürlü', status_closed: 'Kapalı',

  // Stock
  stock_title: 'Stoğum', stock_available_section: 'Mevcut Birimler',
  stock_in_review: 'İnceleniyor', stock_approved_section: 'Onaylandı',
  stock_empty: 'Stoğunuz boş.', stock_request_quote: 'Teklif İste',
  stock_quote_requested: 'Teklif İstendi', stock_my_orders: 'Siparişlerim',

  // Selection
  sel_units_selected: '{count} birim seçili', sel_submit: 'Son Seçimi Gönder',
  sel_review_title: 'Seçiminizi Gözden Geçirin',

  // Containers
  cont_title: 'Konteynerler', cont_no_containers: 'Henüz konteyner yok.',
  cont_destination: 'Varış Noktası', cont_eta: 'Tahmini Varış', cont_seal: 'Mühür No',
  cont_download_bl: 'Konşimento İndir', cont_arrived: 'Konteyner Geldi',
  cont_new_container: 'Yeni Konteyner',

  // Invoices
  invoice_title: 'Faturalar', invoice_action_required: 'İşlem Gerekli',
  invoice_total_invoiced: 'Faturalandırılan', invoice_total_paid: 'Ödenen',
  invoice_outstanding: 'Bekleyen', invoice_overdue: 'Vadesi Geçmiş',
  invoice_upload_receipt: 'Makbuz Yükle', invoice_download_pdf: 'PDF İndir',
  invoice_no_invoices: 'Fatura Yok', invoice_empty_msg: 'Faturalar oluşturulduğunda burada görünecek.',

  // Payments
  pay_title: 'Ödemeler', pay_verified: 'Doğrulanmış Ödemeler',
  pay_no_verified: 'Henüz doğrulanmış ödeme yok.',
  pay_add: 'Ödeme Ekle', pay_outgoing: 'Giden Ödemeler',
  pay_no_outgoing: 'Kaydedilmiş giden ödeme yok.',
  pay_verify: 'Doğrula', pay_reject: 'Reddet',

  // Selection Orders
  selorder_title: 'Seçim Siparişleri', selorder_no_orders: 'Seçim Siparişi Yok',
  selorder_empty_msg: 'Müşteri seçim siparişleri gönderildiğinde burada görünecek.',

  // Requests
  req_title: 'Talepler', req_new: 'Yeni Talep', req_reply: 'Yanıtla',

  // Settings
  settings_title: 'Ayarlar', settings_profile: 'Profilim',

  // Common UI
  ui_all_customers: 'Tüm Müşteriler', ui_export_csv: 'CSV Dışa Aktar',
  ui_edit: 'Düzenle', ui_delete: 'Sil', ui_download: 'İndir',

  // Condition
  cond_good: 'İyi', cond_minor_damage: 'Küçük Hasar',
  cond_major_damage: 'Büyük Hasar', cond_missing_parts: 'Eksik Parçalar',

  // Notifications
  notif_title: 'Bildirimler', notif_no_new: 'Yeni bildirim yok',

  // Misc
  misc_all_customers: 'Tüm Müşteriler', misc_no_data: 'Veri yok',
  misc_loading: 'Yükleniyor...', misc_country: 'Ülke', misc_currency: 'Para Birimi',
};
export default tr;
